import React, {useContext, useEffect, useState } from 'react';

import {Row, Col, DatePicker, TimePicker, Button, notification, Input, Checkbox, Form, Select, Radio} from 'antd';
import localeDatePicker from 'antd/lib/date-picker/locale/ru_RU';

import DividerBlock from "../../../divider-block";
import FieldBlock from '../../../field-block';
import InputField from "../../../input-field";
import NumberInputField from "../../../number-input-field";
import SelectField from "../../../select-field";
import Spinner from '../../../spinner';
import {priceHelper} from '../../../../helpers/price.helper';
import {YMaps, Map, ObjectManager, ZoomControl} from "react-yandex-maps";
import MaskedInput from 'antd-mask-input/build/main/lib/MaskedInput';

import {
  companyService,
  consignorService,
  deliveriesService,
  distributionCenterService,
  systemService,
  trailService
} from "../../../../services";
import {uuidHelper} from "../../../../helpers/uuid.helper";
import moment from "moment/moment";
import { DELIVERY_DEFAULT_TYPE, DELIVERY_AUCTION_PRICE_TYPE, DELIVERY_AUCTION_DATE_TYPE, REDUCTION_TYPE, DELIVERY_MULTIMODAL_TYPE, AUCTION_MULTIMODAL_TYPE, INCOTERM_EXW, INCOTERM_FOB } from '../../../../helpers/delivery.helper';
import { EXTENDED_DELIVERY_INFO } from '../../../../helpers/consignor.helpers';
import i18n from "../../../../i18n";
import {getTranslatedConstant, getTranslatedCountries} from "../../../../helpers/translate.helpers";
import {AppContext} from "../../../../contexts/app-context";
import { crossDockService } from '../../../../services/cross-dock.services';
import Items from './items';
import BulkItems from './bulk-items';
import CostSummary from './cost-summary';

const SHIPMENT_TYPE_PALLETS = 'pallets';
const SHIPMENT_TYPE_BULK = 'bulk';

export default function CreateCrossDock({onCreate = null}) {
  const appContext = useContext(AppContext);

  const {TextArea} = Input;

  const [loading, setLoading] = useState(false);

  const [legalEntitiesList, setLegalEntitiesList] = useState([]);
  const [legalEntitiesListLoaded, setLegalEntitiesListLoaded] = useState(false);

  const [countyList, setCountryList] = useState([]);
  const [regionList, setRegionList] = useState([]);
  const [cityList, setCityList] = useState([]);

  const [translatedCountryList, setTranslatedCountryList] = useState([]);
  const [countyListLoaded, setCountryListLoaded] = useState(false);

  const [countryDeparture, setCountryDeparture] = useState(1);
  const [regionFilter, setRegionFilter] = useState([]);
  const [cityFilter, setCityFilter] = useState([]);

  const [legalEntityId, setLegalEntityId] = useState(null);
  const [number, setNumber] = useState(null);
  const [dateShipment, setDateShipment] = useState(null);
  const [items, setItems] = useState([]);
  const [palletGroups, setPalletGroups] = useState([]);
  const [shipmentType, setShipmentType] = useState(SHIPMENT_TYPE_PALLETS);
  const [isRegime, setIsRegime] = useState(false);

  const [costDelivery, setCostDelivery] = useState(null);
  const [costRePalleting, setCostRePalleting] = useState(null);
  const [costTotal, setCostTotal] = useState(null);
  const [costLoading, setCostLoading] = useState(false);

  const [store, setStore] = useState(null);

  const [storesList, setStoresList] = useState([]);

  let dividerStyle = {
    margin: '15px 0px 45px 0px',
    display: "block",
    clear: "both",
    width: "100%",
    minWidth: "100%",
    height: "1px"
  }

  // Пересчёт стоимости при изменении items (палеты) или palletGroups (валом)
  useEffect(() => {
    if (!legalEntityId) {
      setCostTotal(null);
      return;
    }

    const hasPallets = shipmentType === SHIPMENT_TYPE_PALLETS && items && items.length > 0;
    const hasBulk = shipmentType === SHIPMENT_TYPE_BULK && palletGroups && palletGroups.length > 0;

    if (!hasPallets && !hasBulk) {
      setCostTotal(null);
      return;
    }

    const timer = setTimeout(() => {
      setCostLoading(true);
      let costItems;

      if (shipmentType === SHIPMENT_TYPE_PALLETS) {
        costItems = items.map(item => ({
          storeId: item.storeId,
          totalWeightKg: item.weight,
          skuCount: 0,
          quantity: item.quantity
        }));
      } else {
        costItems = palletGroups.map(group => ({
          storeId: group.storeId,
          totalWeightKg: group.totalWeightKg,
          skuCount: group.items.length,
          quantity: 1
        }));
      }

      crossDockService.calculateCost(costItems)
        .then(data => {
          setCostDelivery(data.deliveryCost);
          setCostRePalleting(data.rePalletingCost);
          setCostTotal(data.totalCost);
        })
        .catch(() => {
          setCostTotal(null);
        })
        .finally(() => setCostLoading(false));
    }, 500);

    return () => clearTimeout(timer);
  }, [items, palletGroups, legalEntityId, shipmentType]);

  useEffect(() => {
    if (!legalEntitiesListLoaded) {
      crossDockService.getLegalEntities()
        .then(res => {
          setLegalEntitiesListLoaded(true);
          setLegalEntitiesList(res);
        })
        .catch(errMsg => {
          setLegalEntitiesListLoaded(true);
          notification.error(
            {
              message: i18n.t('components.notification.titles.getShipperCompaniesListLoaded'),
              description: errMsg
            });
        });
    }
  }, []);

  useEffect(() => {
    setTranslatedCountryList(getTranslatedCountries(countyList));
  },[appContext.lang.lang])

  useEffect(() => {
    if (!countyListLoaded) {
      systemService
        .getCountryList()
        .then(response => {
          setCountryList(response);
          setTranslatedCountryList(getTranslatedCountries(response));
          setCountryListLoaded(true);
        })
        .catch(errorMsg => {
          notification.error({
            message: i18n.t('components.notification.titles.getCountryList'),
            description: errorMsg,
          });
        });
    }
  }, []);

  useEffect(() => {
    if(countryDeparture) {
      crossDockService
        .getRegionsList(countryDeparture)
        .then(data => {
          setRegionList(data);
          setRegionFilter([]);
          setCityList([]);
        })
        .catch(errorMsg => {
          notification.error({
            description: errorMsg,
          });
        });
    }
  },[countryDeparture])

  useEffect(() => {
    if(regionFilter.length > 0) {
      crossDockService
        .getCitiesList(regionFilter)
        .then(data => {
          setCityList(data);
          setCityFilter([]);
        })
        .catch(errorMsg => {
          notification.error({
            description: errorMsg,
          });
        });
    }
  },[regionFilter])

  useEffect(() => {
    if(regionFilter.length > 0) {
      crossDockService
        .getStoresList(regionFilter, cityFilter)
        .then(data => {
          setStoresList(data);
        })
        .catch(errorMsg => {
          notification.error({
            description: errorMsg,
          });
        });
    }
  }, [regionFilter, cityFilter])

  const [fieldsErrors, setFieldsErrors] = useState([]);

  const getFieldErrors = (nameField) => {
    return (fieldsErrors && typeof fieldsErrors[nameField] !== "undefined")
      ? fieldsErrors[nameField][0]
      : null;
  };

  const saveCrossDock = () => {
    setLoading(true);

    let payloadItems;
    if (shipmentType === SHIPMENT_TYPE_PALLETS) {
      payloadItems = items.map(item => {
        const { groupUuid, ...rest } = item;
        return rest;
      });
    } else {
      // bulk: каждый палет = один cross_dock_item с массивом boxes
      payloadItems = palletGroups.map(group => ({
        storeId: group.storeId,
        uuid: group.groupUuid,
        boxes: group.items.map(item => ({
          name: item.name,
          uuid: item.itemUuid,
          boxesCount: item.boxesCount,
          lengthCm: item.boxLengthCm,
          widthCm: item.boxWidthCm,
          heightCm: item.boxHeightCm,
          weightKg: item.boxWeightKg,
          assessedValue: item.assessedValue,
        })),
      }));
    }

    crossDockService.createCrossDock(
      {
        LegalEntityId: legalEntityId,
        Number: number,
        DateShipment: dateShipment,
        ShipmentType: shipmentType,
        IsRegime: isRegime,
        Items: payloadItems,
      }
    )
      .then(response => {
        setLoading(false);
        if (response.code === 400) {
          notification.error({
            message: i18n.t('Создание заявки кросс-докинг'),
            description: response.message,
          });
          setFieldsErrors(response.errors);
        } else {
          notification.success({
            message: i18n.t('Создание заявки кросс-докинг'),
            description: response.message,
          });

          if (typeof onCreate === 'function') {
            onCreate();
          }

          setTimeout(document.location.reload(), 2000);
        }

      })
      .catch(errMsg => {
        setLoading(false);

        notification.error({
          message: i18n.t('Создание заявки кросс-докинг'),
          description: errMsg,
        });
      });

  };

  let bigButtonStyle = { width: '200px', height: '43px', background: '#1CAA53', position: 'static', borderRadius: '10px', borderColor: 'transparent', boxShadow: 'none' };

  return (
    <Spinner loading={(!legalEntitiesListLoaded) || loading}
              tip={i18n.t('main.loadText.loading')}>
      {/* Режимность — скрытая галочка, TODO: раскрыть когда бизнес даст добро */}
      {false && (
        <Row gutter={[16, 24]}>
          <Col lg={24} md={24} sm={24} sx={24}>
            <Checkbox checked={isRegime} onChange={e => setIsRegime(e.target.checked)}>
              Режимный товар
            </Checkbox>
          </Col>
        </Row>
      )}

      {/* Переключатель типа отгрузки */}
      <Row gutter={[16, 24]}>
        <Col lg={24} md={24} sm={24} sx={24}>
          <FieldBlock name="shipmentType" title="Тип отгрузки" getErrors={getFieldErrors}>
            <Radio.Group
              value={shipmentType}
              onChange={e => setShipmentType(e.target.value)}
              buttonStyle="solid"
              size="large"
            >
              <Radio.Button value={SHIPMENT_TYPE_PALLETS}>Палеты</Radio.Button>
              <Radio.Button value={SHIPMENT_TYPE_BULK}>Валом</Radio.Button>
            </Radio.Group>
          </FieldBlock>
        </Col>
      </Row>

      <span className="divider-label">{i18n.t('Основная информация')}</span>
      <DividerBlock style={dividerStyle}/>
      <Row gutter={[16, 24]}>
        <Col lg={24} md={24} sm={24} sx={24}>
          <SelectField
            title={i18n.t('Грузоотправитель')}
            name="legalEntityId"
            selectedValue={legalEntityId}
            values={legalEntitiesList}
            onChange={value => {
              setLegalEntityId(value);
            }}
            getErrors={getFieldErrors}
            style={{width: "100%"}}
          />
        </Col>
      </Row>
      {false && <Row gutter={[16, 24]}>
        <Col lg={12} md={24} sm={24} sx={24}>
          <NumberInputField
            name="number" label={i18n.t('consignorPage.createDelivery.content.number')}
            value={number} setValue={setNumber}
            getFieldErrors={getFieldErrors}
          />
        </Col>
        <Col lg={12} md={24} sm={24} sx={24}>
          <FieldBlock 
            name="dateShipment"
            title={i18n.t(`consignorPage.createDelivery.content.dateOnLoad`)}
            getErrors={getFieldErrors}>
            <DatePicker
              style={{width: "100%"}}
              format="DD.MM.YYYY"
              size="large"
              name="date"
              allowClear={false}
              onChange={value => setDateShipment(value)}
            />
          </FieldBlock>
        </Col>
      </Row>}
      {legalEntityId && <>
      <span className="divider-label">{i18n.t('Фильтр магазинов')}</span>
      <DividerBlock style={dividerStyle}/>
      <Row gutter={[16, 24]}>
          <Col lg={8} md={24} sm={24} sx={24}>
            <SelectField
              title={i18n.t('consignorPage.createDelivery.content.country')}
              name="country"
              selectedValue={countryDeparture}
              values={translatedCountryList}
              onChange={(value, option) => {
                setCountryDeparture(value);
              }}
              getErrors={getFieldErrors}
              style={{width: "100%"}}
            />
          </Col>
          <Col lg={8} md={24} sm={24} sx={24}>
            <SelectField
              title={i18n.t('Регион')}
              name="region"
              mode={'multiple'}
              selectedValue={regionFilter}
              values={regionList}
              onChange={(value, option) => {
                setRegionFilter(value);
              }}
              getErrors={getFieldErrors}
              style={{width: "100%"}}
            />
          </Col>
          <Col lg={8} md={24} sm={24} sx={24}>
            <SelectField
              title={i18n.t('Город')}
              name="city"
              mode={'multiple'}
              selectedValue={cityFilter}
              values={cityList}
              isDisabled={regionFilter.length < 1}
              onChange={(value, option) => {
                setCityFilter(value);
              }}
              getErrors={getFieldErrors}
              style={{width: "100%"}}
            />
          </Col>
      </Row> 
      {shipmentType === SHIPMENT_TYPE_PALLETS && (
        <Items storesList={storesList} items={items} setItems={setItems} fieldsErrors={fieldsErrors} dividerStyle={dividerStyle} legalEntityId={legalEntityId} />
      )}
      {shipmentType === SHIPMENT_TYPE_BULK && (
        <BulkItems
          storesList={storesList}
          palletGroups={palletGroups}
          setPalletGroups={setPalletGroups}
          fieldsErrors={fieldsErrors}
          dividerStyle={dividerStyle}
          legalEntityId={legalEntityId}
        />
      )}

      <CostSummary
        deliveryCost={costDelivery}
        rePalletingCost={costRePalleting}
        totalCost={costTotal}
        loading={costLoading}
      />
      </>}
      <Row gutter={[16, 24]}>
        <Col lg={24} md={24} sm={24} sx={24} style={{textAlign: 'center'}}>
          <Button type="primary" size="large" htmlType="button"
                  onClick={saveCrossDock}
                  style={{margin: '0 5px 10px 0', ...bigButtonStyle}}>{i18n.t('main.buttons.create')}</Button>
        </Col>
      </Row>
    </Spinner>
  );

}